import { render, staticRenderFns } from "./SessionTermination.vue?vue&type=template&id=320b09e4&scoped=true"
import script from "./SessionTermination.vue?vue&type=script&lang=js"
export * from "./SessionTermination.vue?vue&type=script&lang=js"
import style0 from "./SessionTermination.vue?vue&type=style&index=0&id=320b09e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b09e4",
  null
  
)

export default component.exports